<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <CreateEditFornecedorModal
      v-if="showCreateEditFornecedorModal"
      :fornecedorId="fornecedorIdSelected"
      @closeModal="closeCreateEditFornecedorModal"
    />
    <LoadingData v-if="loadData" />
    <div v-else class="card">
      <div
        class="card-header d-flex justify-content-between align-items-center bg-transparent border-bottom"
      >
        <h5 class="card-title mb-0">Fornecedores</h5>
        <div v-if="getModuleUserByCode('1.01.002')">
          <button
            type="button"
            class="btn btn-primary"
            title="Novo Fornecedor"
            @click="createEditFornecedor()"
          >
            <i class="ri-add-fill align-middle"></i>Novo Fornecedor
          </button>
        </div>
      </div>
      <div class="card-body">
        <ListFornecedores
          :fornecedores="fornecedores"
          @editFornecedor="createEditFornecedor"
        />
      </div>
    </div>
  </Layout>
</template>

<script>
import { mapGetters } from 'vuex'
import Layout from '@/views/layouts/Layout.vue'
import PageHeader from '@/components/commons/PageHeader.vue'
import LoadingData from '@/components/commons/LoadingData.vue'
import ListFornecedores from '@/components/fornecedor/ListFornecedores.vue'
import CreateEditFornecedorModal from '@/components/fornecedor/CreateEditFornecedorModal.vue'

export default {
  name: 'Fornecedores',

  components: {
    Layout,
    PageHeader,
    CreateEditFornecedorModal,
    LoadingData,
    ListFornecedores,
  },

  data() {
    return {
      title: 'Fornecedores',
      items: [
        {
          text: 'Fornecedores',
          active: true,
        },
      ],
      loadData: true,
      showCreateEditFornecedorModal: false,
      fornecedores: null,
      fornecedorIdSelected: null,
    }
  },

  computed: {
    ...mapGetters(['getModuleUserByCode']),
  },

  methods: {
    async getFornecedores() {
      try {
        this.fornecedores = await this.$store.dispatch('getFornecedores')
        this.loadData = false
      } catch (error) {
        if (error && error.message) {
          this.$root.$bvToast.toast(error.message, {
            title: 'Atenção!',
            variant: 'warning',
            solid: true,
          })
        } else {
          this.$root.$bvToast.toast(
            'Não foi possível se conectar ao servidor.',
            {
              title: 'Erro!',
              variant: 'danger',
              solid: true,
            },
          )
        }
      }
    },

    createEditFornecedor(fornecedorId) {
      this.fornecedorIdSelected = fornecedorId || null
      this.showCreateEditFornecedorModal = true
    },

    closeCreateEditFornecedorModal(loadListFornecedores) {
      if (loadListFornecedores) {
        this.getFornecedores()
      }
      this.showCreateEditFornecedorModal = false
    },
  },

  mounted() {
    this.getFornecedores()
  },
}
</script>
